import React, { useEffect, useState } from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Select from "react-select";
import { getcorrencycode } from "../../hook/useapi";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import locationicon from "../../assets/gps.png";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const customStyles = {
  control: (provided) => ({
    ...provided,
    padding: "5px",
    backgroundColor: "#f5f5f5",
  }),
  control: (base) => ({
    ...base,
    minWidth: 100,
    borderRadius: "6px",
    // border: "0.5px solid #095228",
    padding: "5px 5px",
    backgroundColor: "#f5f5f5",
  }),
  option: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures it appears on top
};

const SellerInfo = ({
  register,
  handleSubmit,
  errors,
  onSubmit,
  watch,
  setTabs,
  formData,
  setFormdate,
  setValue,
  countries,
  currencydatalist,
  counterdata,
}) => {
  const [country, setCountry] = React.useState(0);
  const { name, flags, countryCallingCode } = countries[country];

  const selectedCountryName = watch("country");
  const [location, setLocation] = useState(null);

  const fullMobile = watch("mobile_number") || "";
  const [callingCode, mobile = ""] = fullMobile.split("-");
  const selectedCountry = countries.find(
    (country) => country.countryCallingCode === callingCode
  ) || countries[195];

  // console.log(currencydatalist);


  // Currency is set automatically from the selected country (it is what buyers are charged in)
  const selectedCountryForCurrency = watch("country");
  useEffect(() => {
    if (!selectedCountryForCurrency) return;
    let cancelled = false;
    (async () => {
      try {
        const resp = await axios.get(`${API_BASE_URL}/seller/get-all-currency-code`, {
          params: { country: selectedCountryForCurrency },
          headers: {
            token:
              sessionStorage.getItem("accessToken") ||
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        });
        if (cancelled) return;
        const code = resp.data?.result?.[0] || "";
        setValue("currency", code, { shouldValidate: Boolean(code) });
      } catch (error) {
        if (!cancelled) setValue("currency", "");
        console.log(error);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [selectedCountryForCurrency, setValue]);

  // console.log("code", currencycode);

  const LOCATIONIQ_KEY="pk.6c6f81fcec628941e7100e983ceb9868";


 const getLocation = () => {
  if (!navigator.geolocation) {
    toast.error("Geolocation not supported");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude } = position.coords;

      try {
        const res = await fetch(
          `https://us1.locationiq.com/v1/reverse.php?key=${LOCATIONIQ_KEY}&lat=${latitude}&lon=${longitude}&format=json`
        );

        const data = await res.json();

        setValue("location", data.display_name);
        toast.success("Location detected");
      } catch (err) {
        toast.error("Failed to detect location");
      }
    },
    () => {
      toast.error("Location permission denied");
    }
  );
};


  return (
    <div className="max-w-3xl mx-auto p-0 sm:p-6 space-y-6">
      {/* Business Name */}
      <div>
        <label className="block font-medium mb-1">Business Name/Individual seller </label>
        <input
          type="text"
          {...register("name", {
            required: "Business Name/Individual seller name  is required",
          })}
          placeholder="Enter Business or Individual Name"
          className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
        />
        {errors.name && (
          <p className="text-sm text-red-500">{errors.name.message}</p>
        )}
      </div>

      {/* Email & Mobile */}
      <div>
        <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-4">
          <div className="w-full sm:w-1/2">
            <label className="block font-medium mb-1">Email</label>
            <input
              type="email"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter a valid email address",
                },
              })}
              placeholder="Enter Your Email"
              className="w-full border rounded-md p-3 outline-none"
            />
            {errors.email && (
              <p className="text-sm text-red-500">{errors.email.message}</p>
            )}
          </div>

          <div className="w-full sm:w-1/2">
            <div className="space-y-2">
              <label className="text-sm font-medium" htmlFor="mobile">
                Mobile Number
              </label>
              <div className="flex space-x-2 items-center">
                <Select
                  options={countries}
                  getOptionLabel={(e) => (
                    <div className="flex items-center">
                      <img
                        src={e.flags.svg}
                        alt={e.name}
                        className="h-4 w-4 rounded-full object-cover mr-2"
                      />
                      {e.countryCallingCode}
                    </div>
                  )}
                  getOptionValue={(e) => e.name}
                  value={selectedCountry}
                  onChange={(option) => {
                    // ✅ update hidden input whenever country changes
                    setValue(
                      "mobile_number",
                      `${option.countryCallingCode}-${mobile}`
                    );
                  }}
                  styles={customStyles}
                  menuPortalTarget={document.body}
                  menuPosition="absolute"
                  placeholder="Select a country"
                />

                <input
                  id="mobile"
                  type="tel"
                  value={mobile}
                  onChange={(e) => {
                    // ✅ update hidden input whenever number changes
                    if (selectedCountry) {
                      setValue(
                        "mobile_number",
                        `${selectedCountry.countryCallingCode}-${e.target.value}`
                      );
                    }
                  }}
                  placeholder="Mobile Number"
                  maxLength={15}
                  className="w-full border rounded-md p-3 outline-none"
                />
              </div>
            </div>

            {/* Hidden input for API submission */}
            <input type="hidden" {...register("mobile_number", {
              required: "Mobile number is required",
              pattern: {
                value: /^\+\d{1,4}-\d{10,15}$/,
                message: "Enter a valid mobile number with 10 to 15 digits",
              },
              maxLength: {
                value: 20,
                message: "Mobile number including country code is too long",
              },
            })} />
            {errors.mobile_number && (
              <p className="text-sm text-red-500">{errors.mobile_number.message}</p>
            )}
          </div>
        </div>
      </div>

      {/* Website */}
      <div>
        <label className="block font-medium mb-1">Website</label>
        <input
          type="text"
          {...register("website", {
            validate: (value) =>
              !value ||
              !value.trim() ||
              /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/i.test(value.trim()) ||
              "Enter a valid website, e.g. www.example.com",
          })}
          placeholder="Enter Your Website"
          className="w-full border rounded-md p-3 outline-none"
        />
        {errors.website && (
          <p className="text-red-500 text-sm mt-1">{errors.website.message}</p>
        )}
      </div>

      {/* Location */}
      <div className="relative w-full">
        <label className="block font-medium mb-1">Location</label>

        <input
          type="text"
          {...register("location", { required: "Location is required" })}
          placeholder="Enter Your Location"
          // readOnly
          className="w-full border rounded-md p-3 pr-10 outline-none"
        />

        {/* Clickable icon on the right */}
        <img
          src={locationicon} // make sure path is correct
          alt="Location"
          onClick={getLocation} // trigger location fetch
          className="absolute right-3 top-10 transform w-6 h-6 cursor-pointer"
        />

        {errors.location && (
          <p className="text-sm text-red-500 mt-1">{errors.location.message}</p>
        )}
      </div>

      {/* Country & Currency */}
      <div className="flex gap-4 flex-col sm:flex-row">
        <div className="w-full sm:w-1/2">
          <label className="block font-medium mb-1">Country</label>
          <select
            {...register("country", { required: "Country is required" })}
            defaultValue="United States of America"
            className="w-full border rounded-md p-3 outline-none"
          >
            <option disabled value="United States of America">
              United States of America
            </option>{" "}
            {counterdata.map((res, i) => (
              <option key={i} value={res.name}>
                {res?.name}
              </option>
            ))}
          </select>
          {errors.country && (
            <p className="text-sm text-red-500">{errors.country.message}</p>
          )}
        </div>

        <div className="w-full sm:w-1/2">
          <label className="block font-medium mb-1">Currency</label>
          <input
            readOnly
            {...register("currency", {
              required: "Currency isn't available for the selected country",
            })}
            placeholder="Select a country"
            title="Set automatically from the selected country"
            className="w-full border rounded-md p-3 outline-none bg-gray-100 text-gray-700 uppercase cursor-not-allowed"
          />
          <p className="text-xs text-gray-500 mt-1">
            Set automatically from your country
          </p>
          {errors.currency && (
            <p className="text-sm text-red-500">{errors.currency.message}</p>
          )}
        </div>
      </div>

      {/* Seller Type */}
      <div>
        <label className="block font-medium mb-2">Seller Type</label>
        <div className="flex flex-col items-center sm:flex-row gap-6">
          <label className="w-full sm:w-1/2 cursor-pointer border rounded-lg p-4 flex flex-row items-start gap-2">
            <input
              type="radio"
              value="individual"
              {...register("Seller_type", {
                required: "Seller type is required",
              })}
              className="accent-green-700"
            />
            <div className="flex flex-col items-center justify-center text-center w-full">
              <img
                src="/image/indidvilesell.png"
                alt="Individual Seller"
                className={`w-[52px] h-[52px] mb-2 transition ${
                  watch("Seller_type") === "individual"
                    ? "opacity-100"
                    : "opacity-30"
                }`}
              />
              <span className="font-medium text-xl">Individual Seller</span>
            </div>
          </label>

          <label className="w-full sm:w-1/2 cursor-pointer border rounded-lg p-4 flex flex-row items-start gap-2">
            <input
              type="radio"
              value="business"
              {...register("Seller_type", {
                required: "Seller type is required",
              })}
              className="accent-green-700"
            />
            <div className="flex flex-col items-center justify-center text-center w-full">
              <img
                src="/image/sellericon.png"
                alt="Business Seller"
                className={`w-[52px] h-[52px] mb-2 transition ${
                  watch("Seller_type") === "business"
                    ? "opacity-100"
                    : "opacity-30"
                }`}
              />
              <span className="font-medium text-xl">Business Seller</span>
            </div>
          </label>
        </div>
        {errors.Seller_type && (
          <p className="text-sm text-red-500">{errors.Seller_type.message}</p>
        )}
      </div>

      {/* Buttons */}
      <div className="flex justify-end mt-6">
        {/* <button
          type="button"
          onClick={() => setTabs(1)}
          className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
        >
          <FaAngleLeft />
          Back
        </button> */}
        <button
          onClick={handleSubmit(() => setTabs(2))}
          className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
        >
          Next
          <FaAngleRight />
        </button>
      </div>
    </div>
  );
};

export default SellerInfo;
